import React from 'react';

// Modo SIMPLES do "Comportamento da IA": destila os ~8 knobs técnicos da aba nos poucos que o leigo
// realmente decide, com microcopy que EXPLICA o efeito. Edita o MESMO estado do avançado (projeção).
// Esconde a sintonia fina (volume mínimo, anti-churn, Top-N, roteamento por finalidade) sob o Avançado.
// Parte do backlog project_backlog_simplified_ui_mode.

// Linha de liga/desliga educativa: switch + título + microcopy do efeito (estado ON e OFF).
function ToggleRow({ id, on, title, onText, offText, onChange }) {
    return (
        <div className="form-check form-switch mb-3">
            <input className="form-check-input" type="checkbox" id={id} checked={on}
                onChange={e => onChange(id, e.target.checked)} />
            <label className="form-check-label fw-bold" htmlFor={id}>{title}</label>
            <small className="d-block text-muted mt-1">{on ? onText : offText}</small>
        </div>
    );
}

function AiBehaviorSimpleView({ settings, onField, onShowAdvanced }) {
    const sharded = (settings.aiSchedulingMode || 'PRIMARY_FALLBACK') === 'SHARDED';
    const learning = settings.aiLearningMode || 'BASIC';

    return (
        <div>
            <ToggleRow id="aiAutoSwitch" on={settings.aiAutoSwitch !== false}
                title="Deixar a IA escolher os ativos"
                onText="Ativo: o scanner troca sozinho os ativos monitorados pelos que estão em melhor momento."
                offText="Desativado: a IA só SUGERE os melhores ativos no Dashboard — você decide o que monitorar."
                onChange={onField} />

            <ToggleRow id="regimeAutoSwitch" on={settings.regimeAutoSwitch !== false}
                title="Adaptar a estratégia ao mercado"
                onText="Ativo: liga a grade automaticamente em mercado lateral e desliga quando vira tendência."
                offText="Desativado: o bot avisa quando o mercado muda, mas você decide quando agir."
                onChange={onField} />

            {/* Orquestração reduzida a um liga/desliga: ON = SHARDED (recomendado), OFF = PRIMARY_FALLBACK. */}
            <ToggleRow id="__sharded" on={sharded}
                title="Usar várias IAs em paralelo (recomendado)"
                onText="Ativo (Distribuído): cada ativo é cuidado por uma IA diferente — a capacidade grátis vira a SOMA de todas as IAs cadastradas."
                offText="Desativado (Primário): uma IA principal atende tudo; as outras só entram se ela falhar ou esgotar."
                onChange={(_id, val) => onField('aiSchedulingMode', val ? 'SHARDED' : 'PRIMARY_FALLBACK')} />

            {/* Aprendizado: 3 níveis simples (o avançado tem a mesma escolha + avisos de custo). */}
            <div className="mb-3">
                <label className="form-label fw-bold mb-1">Quanto a IA aprende com o histórico</label>
                <div className="btn-group w-100" role="group" aria-label="Aprendizado da IA">
                    {[
                        ['OFF', 'Não'],
                        ['BASIC', 'Básico (recomendado)'],
                        ['FULL', 'Detalhado'],
                    ].map(([val, label]) => (
                        <button key={val} type="button"
                            className={`btn btn-sm ${learning === val ? 'btn-primary' : 'btn-outline-primary'}`}
                            onClick={() => onField('aiLearningMode', val)}>{label}</button>
                    ))}
                </div>
                <small className="text-muted d-block mt-1">
                    {learning === 'OFF' && 'A IA decide cada análise do zero (mais barato em tokens).'}
                    {learning === 'BASIC' && 'A IA vê a taxa de acerto e o P&L resumido — bom equilíbrio (poucos tokens extras).'}
                    {learning === 'FULL' && 'A IA vê o histórico detalhado de sinais e resultados (mais tokens por análise).'}
                </small>
            </div>

            <button type="button" className="btn btn-link btn-sm px-0" onClick={onShowAdvanced}>
                ▸ Mostrar parâmetros avançados (Top-N, volume mínimo, IA por finalidade…)
            </button>
        </div>
    );
}

export default AiBehaviorSimpleView;
